import { useMemo, useState } from 'react';

type useBoolReturn = [
  // The Value
  boolean,
  // Set True
  () => void,
  // Set False
  () => void
];

const useBool = (initialValue?: boolean): useBoolReturn => {
  const [bool, setBool] = useState<boolean>(initialValue || false);

  const [setTrue, setFalse] = useMemo(
    () => [() => setBool(true), () => setBool(false)],
    []
  );

  return [bool, setTrue, setFalse];
};

export default useBool;
